var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader"},[_c('h1',{staticClass:"heading"},[_vm._v(" Redirection in progress ")]),_c('p',{staticClass:"animate"},[_vm._v(" please wait... ")])])
}]

export { render, staticRenderFns }